import baseScmService from 'services/baseScmService';
import libraryService from './libraryService';
import updateLibraryAcademyTopicOrder from '../utils/updateLibraryAcademyTopicOrder';

const libraryAcademyTopicService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    deleteLibraryAcademyTopic: build.mutation({
      query: ({ id }) => ({
        method: 'DELETE',
        url: `library-academy-topics/${id}`,
      }),
      invalidatesTags: (result, error, { libraryId }) =>
        error ? [] : [{ type: 'Library', id: libraryId }],
    }),
    moveLibraryAcademyTopic: build.mutation({
      query: ({ id, libraryId, newOrder }) => ({
        method: 'PUT',
        url: `library-academy-topics/${id}/move`,
        body: {
          library_academy_topic: {
            order: newOrder,
          },
        },
      }),
      // Logic for optimistic update UX.
      // Read more at https://redux-toolkit.js.org/rtk-query/usage/manual-cache-updates#optimistic-updates
      async onQueryStarted(
        { id, libraryId, newOrder },
        { dispatch, queryFulfilled }
      ) {
        const updateResult = dispatch(
          libraryService.util.updateQueryData(
            'getLibrary',
            String(libraryId),
            (draft) => {
              updateLibraryAcademyTopicOrder({
                library: draft.data,
                libraryAcademyTopicId: id,
                newOrder,
              });
            }
          )
        );
        try {
          await queryFulfilled;
        } catch (error) {
          // If move fails undo it and show a message to the user about it.
          updateResult.undo();
        }
      },
      invalidatesTags: (result, error, { libraryId }) =>
        error ? [] : [{ type: 'Library', id: libraryId }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useDeleteLibraryAcademyTopicMutation,
  useMoveLibraryAcademyTopicMutation,
} = libraryAcademyTopicService;

export default libraryAcademyTopicService;
